import { apiUrl2 } from '../../../settings'

export const deactivatedUsersListUrl = () => {
  return apiUrl2 + '/api/deactivate-users'
}
